import { DataLinkPage } from '../../DataLink';

const DataArticle = {
  path: DataLinkPage.edu_jenisProdukAsuransiJiwa,
  preview: {
    title: [
      {
        text: 'Jenis Produk Asuransi Jiwa',
      },
    ],
    subInfo: {
      author: 'Rivo Bifa',
      linkProfile: DataLinkPage.author_rivoBifa,
      timestamp: 'Selasa, 25 Januari 2022',
      location: 'Jakarta',
    },
    content: [
      {
        paragraph: [
          [
            {
              text: 'Artikel ini akan membahas tentang jenis-jenis produk dasar pada asuransi jiwa yaitu ',
            },
            {
              text: 'Pure Endowment',
              type: 'ins-term',
            },
            {
              text: ', ',
            },
            {
              text: 'Term Life Insurance',
              type: 'ins-term',
            },
            {
              text: ', ',
            },

            {
              text: 'Whole Life Insurance',
              type: 'ins-term',
            },
            {
              text: ', dan ',
            },

            {
              text: 'Endowment Insurance',
              type: 'ins-term',
            },
            {
              text: ' dengan menggunakan definisi dari para ahli asuransi yang akan menambah wawasan kita semua.',
            },
          ],
        ],
      },
      // {
      //   previewArticle: DPAImage.jenisProdukAsuransiJiwa,
      // },
    ],
  },
  section: [
    {
      title: [
        {
          text: 'Pure Endowment',
          type: 'italic',
        },
      ],
      content: [
        {
          paragraph: [
            [
              {
                text: 'Pure Endowment',
                type: 'ins-term',
              },
              {
                text: ' (Asuransi Pure Endowment) merupakan produk asuransi jiwa dengan ',
              },
              {
                text: 'Manfaat Asuransi',
                type: 'ins-term',
              },
              {
                text: ' yang akan diterima jika Peserta masih hidup pada saat periode pertanggungan berakhir. Kalimat ini ',
              },
              {
                text: 'gue',
                type: 'italic',
              },
              {
                text: ' kutip dari Pak Abbas Salim selaku ahli asuransi.',
              },
            ],
          ],
        },
        {
          quote: {
            content: [
              {
                text: 'Pure Endowment',
                type: 'ins-term',
              },
              {
                text: ' adalah suatu kontrak yang akan membayar manfaat hanya kepada mereka yang tetap hidup sampai periode tertentu, mereka yang tidak dapat hidup sampai periode tertentu tersebut tidak menerima apa-apa.',
              },
            ],
            author: { text: 'GENE A. MORTON, 1995:56' },
            source: {
              text: 'Dasar-Dasar Asuransi Jiwa dan Asuransi Kesehatan',
            },
          },
        },
        {
          paragraph: [
            [
              {
                text: 'Produk ini tidak memproteksi kerugian finansial jika Peserta meninggal, melainkan “jaminan pembayaran manfaat bila Peserta masih hidup”. Salah satu fungsinya adalah sebagai tabungan yang dapat menghindari inflasi.',
              },
            ],
            [
              {
                text: 'Contoh, seseorang memenangkan hadiah lotre atau undian dengan total uang mencapai miliyaran. Coba bayangin kalau dia menyimpannya sendiri, bisa saja uang tersebut langsung habis ia pakai atau mengalami depresiasi jika tidak digunakan. Serba salah kan? Hehe… Nah dari sini produk ',
              },
              {
                text: 'Pure Endowment',
                type: 'ins-term',
              },
              {
                text: ' akan membantu dalam menyimpannya. Ketika periode pertanggungan telah berakhir maka ',
              },
              {
                text: 'Manfaat Asuransi',
                type: 'ins-term',
              },
              {
                text: ' akan diberikan sesuai dengan tingkat bunga dan ',
              },
              {
                text: 'survivorship',
                type: 'italic',
              },
              {
                text: ' (peluang jumlah orang yang hidup) yang berlaku. Kombinasi tingkat bunga dan ',
              },
              {
                text: 'survivorship',
                type: 'italic',
              },
              {
                text: ' akan memberikan nilai yang lebih tinggi jika dibandingkan tingkat bunga saja. Misalnya, orang tersebut berusia 35 tahun menyimpan uang sebesar Rp 490 juta di bank dengan tingkat bunga 3% selama 20 tahun mungkin di akhir tahun ke-20 hanya memperoleh sekitar Rp 880 juta saja, tapi jika ia membeli produk ',
              },
              {
                text: 'Pure Endowment',
                type: 'ins-term',
              },
              {
                text: ' dengan tabel mortalita CSO 1958, bisa saja ia memperoleh Rp 1 milyar ketika periode pertanggungannya berakhir. Nantinya uang Rp 1 milyar itu bisa diterima sekaligus atau berangsur per bulan seperti menerima gaji.',
              },
            ],
            [
              {
                text: 'Pengembangan dari konsep produk ini bisa kita temukan pada produk dana pensiun. Pesertanya membayar ',
              },
              {
                text: 'Premi',
                type: 'ins-term',
              },
              {
                text: ' dengan jaminan manfaat pensiun pada akhir kontrak kerja yang dapat diterima sekaligus atau berangsur per bulan seperti menerima gaji.',
              },
            ],
            [
              {
                text: 'Pengembangan lain juga bisa kita temukan pada produk asuransi pendidikan dimana ',
              },
              {
                text: 'Manfaat Asuransi',
                type: 'ins-term',
              },
              {
                text: ' akan diberikan jika Peserta/ yang ditunjuk sebagai Peserta/ Anak Peserta beranjak dewasa dan membutuhkan uang pendidikan (SD/ SMP/ SMA/ Kuliah). Namun, dalam produk ini biasanya juga melekat asuransi jiwa yang ',
              },
              {
                text: 'Manfaat Asuransi',
                type: 'ins-term',
              },
              {
                text: '-nya juga diberikan walaupun meninggal sehingga lebih mirip seperti produk ',
              },
              {
                text: 'Endowment Insurance',
                type: 'ins-term',
              },
              {
                text: '.',
              },
            ],
            [
              {
                text: 'Pembayaran ',
              },
              {
                text: 'Premi',
                type: 'ins-term',
              },
              {
                text: ' pada produk ini umumnya berlaku sesuai jangka waktu polis. Contoh, ',
              },
              {
                text: 'Premi',
                type: 'ins-term',
              },
              {
                text: ' akan dicicil selama 10 tahun jika Peserta membeli produk ini dengan jangka waktu atau periode pertanggungan selama 10 tahun. Namun, beberapa Perusahaan Asuransi memperbolehkan Pesertanya untuk membayar sekaligus (1x bayar).',
              },
            ],
            [
              {
                text: 'Di ',
              },
              {
                text: 'Kalkulator Asuransi',
                type: 'link-page',
                path: DataLinkPage.calc_home,
              },
              {
                text: ', periode cicilan untuk produk ini secara ',
              },
              {
                text: 'default',
                type: 'italic',
              },
              {
                text: ' akan ditetapkan sebesar periode pertanggungan. ',
              },
              {
                text: 'Lo',
                type: 'italic',
              },
              {
                text: ' bisa mengubah periode cicilan ini dengan ',
              },
              {
                text: 'click',
                type: 'italic',
              },
              {
                text: ' tombol ',
              },
              {
                text: 'Tampilkan Opsi Lanjutan',
                type: 'bold',
              },
              {
                text: '.',
              },
            ],
          ],
        },
      ],
    },
    {
      title: [
        {
          text: 'Term Life Insurance',
          type: 'italic',
        },
      ],
      content: [
        {
          paragraph: [
            [
              {
                text: 'Term Life Insurance',
                type: 'ins-term',
              },
              {
                text: ' (Asuransi Jiwa Berjangka) merupakan produk asuransi jiwa dengan ',
              },
              {
                text: 'Manfaat Asuransi',
                type: 'ins-term',
              },
              {
                text: ' yang akan diterima jika Peserta mengalami kematian pada saat periode pertanggungan berjalan. Kalimat ini ',
              },
              {
                text: 'gue',
                type: 'italic',
              },
              {
                text: ' kutip dari Pak Abbas Salim selaku ahli asuransi.',
              },
            ],
          ],
        },
        {
          quote: {
            content: [
              {
                text: 'Term Life Insurance',
                type: 'ins-term',
              },
              {
                text: ' merupakan suatu bentuk pertanggungan yang mempunyai jangka waktu tertentu.',
              },
            ],
            author: { text: 'ABBAS SALIM, 2007:34' },
            source: { text: 'Asuransi dan Manajemen Risiko' },
          },
        },
        {
          paragraph: [
            [
              {
                text: 'Proteksi pada produk ini dapat didefinisikan sebagai “proteksi kerugian finansial jika Peserta meninggal” dan berlaku mulai dari Peserta secara sah membeli produk sampai dengan jangka waktu yang tertulis di dalam polis. Maka dari itu, ',
              },
              {
                text: 'Klaim',
                type: 'ins-term',
              },
              {
                text: ' atau ',
              },
              {
                text: 'Manfaat Asuransi',
                type: 'ins-term',
              },
              {
                text: ' pada produk ini hanya bisa diperoleh jika Peserta meninggal pada saat periode pertanggungan berjalan dan akan diberikan sebagai santunan untuk ahli waris yang ditinggalkannya (keluarga yang ditinggal). Apabila Peserta masih hidup pada saat periode pertanggungan berakhir, ia tidak akan menerima ',
              },
              {
                text: 'Manfaat Asuransi',
                type: 'ins-term',
              },
              {
                text: ' karena risiko tidak terjadi.',
              },
            ],
            [
              {
                text: 'Pembayaran ',
              },
              {
                text: 'Premi',
                type: 'ins-term',
              },
              {
                text: ' pada produk ini umumnya berlaku sesuai jangka waktu polis. Contoh, ',
              },
              {
                text: 'Premi',
                type: 'ins-term',
              },
              {
                text: ' akan dicicil selama 5 tahun jika Peserta membeli produk ini dengan jangka waktu atau periode pertanggungan selama 5 tahun. Namun, beberapa Perusahaan Asuransi memperbolehkan Pesertanya untuk membayar sekaligus (1x bayar).',
              },
            ],
            [
              {
                text: 'Di ',
              },
              {
                text: 'Kalkulator Asuransi',
                type: 'link-page',
                path: DataLinkPage.calc_home,
              },
              {
                text: ', periode cicilan untuk produk ini secara ',
              },
              {
                text: 'default',
                type: 'italic',
              },
              {
                text: ' akan ditetapkan sebesar periode pertanggungan. ',
              },
              {
                text: 'Lo',
                type: 'italic',
              },
              {
                text: ' bisa mengubah periode cicilan ini dengan ',
              },
              {
                text: 'click',
                type: 'italic',
              },
              {
                text: ' tombol ',
              },
              {
                text: 'Tampilkan Opsi Lanjutan',
                type: 'bold',
              },
              {
                text: '.',
              },
            ],
          ],
        },
      ],
    },
    {
      title: [
        {
          text: 'Whole Life Insurance',
          type: 'italic',
        },
      ],
      content: [
        {
          paragraph: [
            [
              {
                text: 'Whole Life Insurance',
                type: 'ins-term',
              },
              {
                text: ' (Asuransi Jiwa Seumur Hidup) merupakan produk asuransi jiwa dengan ',
              },
              {
                text: 'Manfaat Asuransi',
                type: 'ins-term',
              },
              {
                text: ' yang akan diterima jika Peserta mengalami kematian kapan pun kematian tersebut terjadi. Kalimat ini ',
              },
              {
                text: 'gue',
                type: 'italic',
              },
              {
                text: ' kutip dari Pak Sudarto selaku ahli asuransi.',
              },
            ],
          ],
        },
        {
          quote: {
            content: [
              {
                text: 'Polis ',
              },
              {
                text: 'Whole Life Insurance',
                type: 'ins-term',
              },
              {
                text: ' menyatakan bahwa ',
              },
              {
                text: 'Klaim',
                type: 'ins-term',
              },
              {
                text: ' kematian akan dibayar kapan saja kematian itu terjadi.',
              },
            ],
            author: { text: 'SUDARTO, 1976:62' },
            source: { text: 'Dasar-Dasar Ilmu Pasti Asuransi Jiwa' },
          },
        },
        {
          paragraph: [
            [
              {
                text: 'Proteksi pada produk ini dapat didefinisikan sebagai “proteksi kerugian finansial jika Peserta meninggal” dan berlaku mulai dari Peserta secara sah membeli produk sampai dengan ia meninggal. Maka dari itu, ',
              },
              {
                text: 'Klaim',
                type: 'ins-term',
              },
              {
                text: ' atau ',
              },

              {
                text: 'Manfaat Asuransi',
                type: 'ins-term',
              },
              {
                text: ' pada produk ini umumnya hanya bisa diperoleh sebagai santunan untuk ahli waris yang ditinggalkannya (keluarga yang ditinggal). Namun, dalam beberapa kasus bisa berbeda di mana Peserta masih bisa menerima ',
              },

              {
                text: 'Manfaat Asuransi',
                type: 'ins-term',
              },
              {
                text: ' itu sendiri tanpa diberikan kepada ahli waris. Hal tersebut ',
              },

              {
                text: 'gue',
                type: 'italic',
              },
              {
                text: ' coba jelasin di ',
              },
              {
                text: 'Mengenal Lebih Dalam Whole Life Insurance',
                type: 'link-page',
                path: DataLinkPage.edu_mengenalLebihDalamWholeLifeInsurance,
              },
              {
                text: '.',
              },
            ],
            [
              {
                text: 'Meskipun produk ini berlaku seumur hidup, Perusahaan Asuransi umumnya akan memberikan pilihan pembayaran ',
              },
              {
                text: 'Premi',
                type: 'ins-term',
              },
              {
                text: ' kepada calon Pesertanya apakah ingin membayar secara sekaligus (1x bayar) atau mencicilnya (…x bayar). Dalam mencicilnya pun Peserta masih bisa memilih apakah periode cicilannya hanya 5 tahun, 10 tahun, atau dicicil seumur hidupnya (mencicil hingga ia meninggal).',
              },
            ],
            [
              {
                text: 'Di ',
              },
              {
                text: 'Kalkulator Asuransi',
                type: 'link-page',
                path: DataLinkPage.calc_home,
              },
              {
                text: ', periode cicilan untuk produk ini secara ',
              },
              {
                text: 'default',
                type: 'italic',
              },
              {
                text: ' akan ditetapkan sebesar ',
              },
              {
                text: '111 - usia',
                type: 'ins-term',
              },
              {
                text: ' yang mana 111 adalah batas dari tabel mortalita. ',
              },
              {
                text: 'Lo',
                type: 'italic',
              },
              {
                text: ' bisa mengubah periode cicilan ini dengan ',
              },
              {
                text: 'click',
                type: 'italic',
              },
              {
                text: ' tombol ',
              },
              {
                text: 'Tampilkan Opsi Lanjutan',
                type: 'bold',
              },
              {
                text: '.',
              },
            ],
          ],
        },
      ],
    },
    {
      title: [
        {
          text: 'Endowment Insurance',
          type: 'italic',
        },
      ],
      content: [
        {
          paragraph: [
            [
              {
                text: 'Endowment Insurance',
                type: 'ins-term',
              },
              {
                text: ' (Asuransi Jiwa Dwiguna) merupakan produk asuransi jiwa dengan ',
              },
              {
                text: 'Manfaat Asuransi',
                type: 'ins-term',
              },
              {
                text: ' yang akan diterima jika Peserta mengalami kematian pada saat periode pertanggungan berjalan atau masih hidup pada saat periode pertanggungan berakhir. Kalimat ini ',
              },
              {
                text: 'gue',
                type: 'italic',
              },
              {
                text: ' kutip dari Pak Morton selaku ahli asuransi.',
              },
            ],
          ],
        },
        {
          quote: {
            content: [
              {
                text: 'Kontrak ',
              },
              {
                text: 'Asuransi Endowment',
                type: 'ins-term',
              },
              {
                text: ' menyediakan manfaat pasti, apakah tertanggung masih hidup sampai habis kontrak atau kah ia meninggal sebelum itu.',
              },
            ],
            author: { text: 'GENE A. MORTON, 1995:57' },
            source: {
              text: 'Dasar-Dasar Asuransi Jiwa dan Asuransi Kesehatan',
            },
          },
        },
        {
          paragraph: [
            [
              {
                text: 'Sesuai dengan namanya “Dwiguna” berarti manfaat dari produk ini dapat diterima dengan dua kondisi yaitu:',
              },
            ],
          ],
        },
        {
          list: {
            content: [
              [
                {
                  text: 'Peserta meniggal pada saat periode pertanggungan berjalan yang nantinya ',
                },
                {
                  text: 'Manfaat Asuransi',
                  type: 'ins-term',
                },
                {
                  text: ' atau ',
                },
                {
                  text: 'Klaim',
                  type: 'ins-term',
                },
                {
                  text: ' akan diterima oleh ahli waris yang ditinggalkan, atau',
                },
              ],
              [
                {
                  text: 'Peserta masih hidup pada saat periode pertanggungan berakhir yang nantinya ',
                },
                {
                  text: 'Manfaat Asuransi',
                  type: 'ins-term',
                },
                {
                  text: ' atau ',
                },
                {
                  text: 'Klaim',
                  type: 'ins-term',
                },
                {
                  text: ' akan diterima langsung oleh Peserta.',
                },
              ],
            ],
          },
        },
        {
          paragraph: [
            [
              {
                text: 'Tentunya Peserta hanya bisa memperoleh ',
              },
              {
                text: 'Manfaat Asuransi',
                type: 'ins-term',
              },
              {
                text: ' dari salah satu kondisi di atas. Dua kondisi di atas tidak mungkin menjadikan Peserta memperoleh ',
              },
              {
                text: 'Manfaat Asuransi',
                type: 'ins-term',
              },
              {
                text: ' sebanyak dua kali.',
              },
            ],
            [
              {
                text: 'Dua kondisi tersebut merupakan gabungan dari produk ',
              },
              {
                text: 'Term Life Insurance',
                type: 'ins-term',
              },
              {
                text: ' dan ',
              },
              {
                text: 'Pure Endowment',
                type: 'ins-term',
              },
              {
                text: '. ',
              },
              {
                text: 'Term Life Insurance',
                type: 'ins-term',
              },
              {
                text: ' akan memberikan ',
              },
              {
                text: 'Manfaat Asuransi',
                type: 'ins-term',
              },
              {
                text: ' apabila Peserta meninggal pada saat periode pertanggungan berjalan (kondisi 1), sedangkan ',
              },
              {
                text: 'Pure Endowment',
                type: 'ins-term',
              },
              {
                text: ' akan memberikan ',
              },
              {
                text: 'Manfaat Asuransi',
                type: 'ins-term',
              },
              {
                text: ' apabila Peserta masih hidup pada saat periode pertanggungan berakhir (kondisi 2). Kalimat ini ',
              },
              {
                text: 'gue',
                type: 'italic',
              },
              {
                text: ' kutip dari Pak Takashi selaku ahli asuransi.',
              },
            ],
          ],
        },
        {
          quote: {
            content: [
              {
                text: 'Suatu jenis asuransi yang merupakan gabungan dari ',
              },
              {
                text: 'Asuransi Pure Endowment',
                type: 'ins-term',
              },
              {
                text: ' dan ',
              },
              {
                text: 'Asuransi Berjangka',
                type: 'ins-term',
              },
              {
                text: ' yang berarti dalam periode maupun saat berakhirnya masa pertanggungan kepada pemegang polis, baik meninggal maupun bertahan hidup akan dibayar uang pertanggungan.',
              },
            ],
            author: { text: 'TAKASHI FUTAMI, 1993:88' },
            source: { text: 'Matematika Asuransi Jiwa Bagian I' },
          },
        },

        {
          paragraph: [
            [
              {
                text: 'Pembayaran ',
              },

              {
                text: 'Premi',
                type: 'ins-term',
              },
              {
                text: ' pada produk ini umumnya juga berlaku seperti ',
              },

              {
                text: 'Term Life Insurance',
                type: 'ins-term',
              },
              {
                text: ' yaitu sesuai jangka waktu polis. Contoh, ',
              },
              {
                text: 'Premi',
                type: 'ins-term',
              },
              {
                text: ' akan dicicil selama 25 tahun jika Peserta membeli produk ini dengan jangka waktu atau periode pertanggungan selama 25 tahun. Namun, beberapa Perusahaan Asuransi memperbolehkan Pesertanya untuk membayar sekaligus (1x bayar).',
              },
            ],
            [
              {
                text: 'Di ',
              },
              {
                text: 'Kalkulator Asuransi',
                type: 'link-page',
                path: DataLinkPage.calc_home,
              },
              {
                text: ', periode cicilan untuk produk ini secara ',
              },
              {
                text: 'default',
                type: 'italic',
              },
              {
                text: ' akan ditetapkan sebesar periode pertanggungan. ',
              },
              {
                text: 'Lo',
                type: 'italic',
              },
              {
                text: ' bisa mengubah periode cicilan ini dengan ',
              },
              {
                text: 'click',
                type: 'italic',
              },
              {
                text: ' tombol ',
              },
              {
                text: 'Tampilkan Opsi Lanjutan',
                type: 'bold',
              },
              {
                text: '.',
              },
            ],
          ],
        },
      ],
    },
  ],
  conclusion: {
    title: [
      {
        text: 'Kesimpulan',
      },
    ],
    content: [
      {
        paragraph: [
          [
            {
              text: 'Produk asuransi jiwa dapat kita definisikan sebagai:',
            },
          ],
        ],
      },
      {
        list: {
          content: [
            [
              {
                text: 'Pure Endowment',
                type: 'ins-term',
              },
              {
                text: ' merupakan produk asuransi jiwa dengan ',
              },
              {
                text: 'Manfaat Asuransi',
                type: 'ins-term',
              },
              {
                text: ' yang akan diterima jika Peserta masih hidup pada akhir periode.',
              },
            ],
            [
              {
                text: 'Term Life Insurance',
                type: 'ins-term',
              },
              {
                text: ' merupakan produk asuransi jiwa dengan ',
              },
              {
                text: 'Manfaat Asuransi',
                type: 'ins-term',
              },
              {
                text: ' yang akan diterima jika Peserta meninggal dalam periode.',
              },
            ],
            [
              {
                text: 'Whole Life Insurance',
                type: 'ins-term',
              },
              {
                text: ' merupakan produk asuransi jiwa dengan ',
              },
              {
                text: 'Manfaat Asuransi',
                type: 'ins-term',
              },
              {
                text: ' yang akan diterima jika Peserta meninggal (tanpa batas periode).',
              },
            ],
            [
              {
                text: 'Endowment Insurance',
                type: 'ins-term',
              },
              {
                text: ' merupakan produk asuransi jiwa dengan ',
              },
              {
                text: 'Manfaat Asuransi',
                type: 'ins-term',
              },
              {
                text: ' yang akan diterim jika Peserta meninggal dalam periode atau masih hidup pada akhir periode tersebut.',
              },
            ],
          ],
        },
      },
      {
        paragraph: [
          [
            {
              text: 'Perlu dicatat, dari keempat jenis produk asuransi jiwa yang dituliskan di sini, produk ',
            },
            {
              text: 'Endowment Insurance',
              type: 'ins-term',
            },
            {
              text: ' merupakan produk dengan ',
            },
            {
              text: 'Premi',
              type: 'ins-term',
            },
            {
              text: ' termahal dikarenakan hadirnya dua kondisi pada produk ',
            },

            {
              text: 'Endowment Insurance',
              type: 'ins-term',
            },
          ],
          [
            {
              text: 'Reminder',
              type: 'italic',
            },
            {
              text: ' untuk temen-temen, produk ',
            },
            {
              text: 'Pure Endowment',
              type: 'ins-term',
            },
            {
              text: ' dan ',
            },
            {
              text: 'Endowment Insurance',
              type: 'ins-term',
            },
            {
              text: ' adalah dua produk yang berbeda. Jangan sampai keliru yaa!',
            },
          ],
        ],
      },
    ],
  },
};

export default DataArticle;
